module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Site Page Gallery */

(function(fox) { fox.registerWidget('SitePage_Gallery', {}, 'Site_Page'); })(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./widget/sitepage/gallery.js
// module id = 1276
// module chunks = 4